// extracted by mini-css-extract-plugin
export var container = "_4v-0";
export var error = "_4v-9";
export var label = "_4v-5";
export var light = "_4v-6";
export var md = "_4v-3";
export var sm = "_4v-2";
export var thin = "_4v-8";
export var thinBold = "_4v-7";
export var vertical = "_4v-4";
export var xs = "_4v-1";